module.exports = __webpack_public_path__ + "static/img/img8.0fcea39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/img8.png
// module id = WWui
// module chunks = 1